import "../../styles.css";

const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy-container">
            <header className="privacy-policy-header">
                <h1>Privacy Policy</h1>
                <h2>Gig Genie</h2>
            </header>

            <section className="privacy-policy-section">
                <h3>Introduction</h3>
                <p>Welcome to the Privacy Policy of Gig Genie. Your privacy is important to us, and this document outlines how we handle your data.</p>
            </section>

            <section className="privacy-policy-section">
                <h3>Information We Collect</h3>
                <p>Gig Genie does NOT collect personal data. No names, no emails, no usage tracking, and no analytics are collected. All app data is stored locally on the user’s device only.</p>
            </section>

            <section className="privacy-policy-section">
                <h3>How Your Data Is Used</h3>
                <p>Since we do not collect any personal data, there is no data usage to disclose. All app data remains on your device.</p>
            </section>

            <section className="privacy-policy-section">
                <h3>Data Storage</h3>
                <p>All data is stored locally on the user’s device. Deleting the app will remove all locally stored data.</p>
            </section>

            <section className="privacy-policy-section">
                <h3>Third-Party Services</h3>
                <p>RevenueCat is used ONLY for subscription management. RevenueCat may process anonymous purchase/receipt data. The developer does not access or store this data directly.</p>
            </section>

            <section className="privacy-policy-section">
                <h3>Children’s Privacy</h3>
                <p>The app is not directed at children under 13. No knowing collection of children’s data occurs.</p>
            </section>

            <section className="privacy-policy-section">
                <h3>Changes to This Policy</h3>
                <p>Changes to this Privacy Policy will be reflected on this page. Please review it periodically for updates.</p>
            </section>

            <section className="privacy-policy-section">
                <h3>Contact Information</h3>
                <p>If you have any questions or concerns about this Privacy Policy, please contact us at <a href="mailto:mygiggenie@gmail.com">mygiggenie@gmail.com</a>.</p>
            </section>
        </div>
    );
};

export default PrivacyPolicy;